import React from 'react';
import clsx from 'clsx';
import CloseIcon from '~/icons/close.svg';
import SearchIcon from '~/icons/search.svg';
import { useTranslation } from '~/shared/utils/translation';
import styles from './StoreAvailabilitySearchInput.module.scss';

type Props = {
    value: string;
    setValue: (value: string) => void;
    inputRef?: React.Ref<HTMLInputElement>;
    className?: string;
};

// Matches RefinementSearchInput's grey-fill look per Figma, unlike StoreSearchInput's bordered style used elsewhere.
export const StoreAvailabilitySearchInput = ({ value, setValue, inputRef, className }: Props) => {
    const { translate } = useTranslation();

    const handleClear = () => {
        setValue('');

        if (inputRef && typeof inputRef !== 'function') {
            inputRef.current?.focus();
        }
    };

    return (
        <div className={clsx(styles.inputWrapper, className)}>
            <SearchIcon width="24" height="24" />
            <input
                ref={inputRef}
                className={styles.inputField}
                aria-label={translate('findStore.searchZipCode')}
                placeholder={translate('findStore.searchZipCode')}
                value={value}
                onChange={(event) => setValue(event.target.value)}
            />
            {value && (
                <button
                    className={styles.close}
                    onClick={handleClear}
                    type="button"
                    aria-label={translate('header.closeSearch')}
                >
                    <CloseIcon />
                </button>
            )}
        </div>
    );
};

export default StoreAvailabilitySearchInput;
